import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import {
  Wizard,
  WizardDeletePayload,
  WizardDeleteValidationItem,
  WizardDeleteValidationPayload,
  WizardListResponse,
  WizardRestorePayload,
} from './models/wizard';

const wizardService = {
  getAll(): Promise<CommonResponse<Array<WizardListResponse>>> {
    let url = `/wizards`;

    return axiosClient.get(url);
  },
  delete(payload: WizardDeletePayload): Promise<CommonResponse<any>> {
    const url = `/wizards`;
    return axiosClient.delete(url, { data: payload });
  },
  restore(payload: WizardRestorePayload): Promise<CommonResponse<any>> {
    const url = `/wizards/restore`;
    return axiosClient.patch(url, payload);
  },
  checkDeleteValidation(
    payload: WizardDeleteValidationPayload
  ): Promise<CommonResponse<Array<WizardDeleteValidationItem>>> {
    const url = `/wizards/delete-validation`;
    return axiosClient.post(url, payload);
  },
  getItem(id: number): Promise<CommonResponse<Wizard>> {
    const url = `/wizard/${id}`;
    return axiosClient.get(url);
  },
  add(payload: Partial<Wizard>): Promise<CommonResponse<any>> {
    const url = '/wizards';
    return axiosClient.post(url, payload);
  },
  update(id: number, payload: Partial<Wizard>): Promise<CommonResponse<any>> {
    const url = `/wizard/${id}`;
    return axiosClient.patch(url, payload);
  },
};

export default wizardService;
